import { render, staticRenderFns } from "./CommissionReport.vue?vue&type=template&id=0704e930"
import script from "./CommissionReport.vue?vue&type=script&lang=js"
export * from "./CommissionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports